import React, { useState } from "react";
import PublishIcon from "@mui/icons-material/Publish";
import { Box, Typography, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DEFAULT_IMAGEBOSS_URL } from "../../../utils/S3";
import AuthService from "../../../AuthService";

const CoverContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundColor: "#ddd",
  backgroundPosition: "center",
  borderRadius: theme.spacing(0.5),
  overflow: "hidden",
}));

const CoverLabel = styled("label")(({ theme }) => ({
  cursor: "pointer",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  transition: "0.2s",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  opacity: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    opacity: 1,
  },
  "&:after": {
    content: '""',
    position: "absolute",
    top: theme.spacing(1.5),
    left: theme.spacing(1.5),
    right: theme.spacing(1.5),
    bottom: theme.spacing(1.5),
    border: "3px dashed #ddd",
  },
}));

const CoverLabelEmpty = styled(CoverLabel)({
  backgroundColor: "transparent",
  opacity: 1,
});

const CoverLoading = styled(Box)({
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "rgba(0, 0, 0, 0.3)",
});

function CoverInput({ empresa, onSubmit, onUpdateCompany }) {
  const [loading, setLoading] = useState(false);
  const URL_IMAGEBOSS = DEFAULT_IMAGEBOSS_URL + "/cover:center/1200x300/";

   // ADICIONADO - Instância do serviço de API
  const service = new AuthService();

async function uploadFileServer(file) {
    if (loading || !file) return;

    setLoading(true);

    try {
      // 1. Chamar seu backend para obter a URL assinada
      const presignedResponse = await service.post("/S3Service/generate-presigned-url", {
        fileName: file.name,
        fileType: file.type,
        empresaId: empresa.id,
      });

      const { uploadUrl, key } = presignedResponse;

      // 2. Fazer o upload do arquivo para o S3 com a URL recebida
      const uploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (!uploadResponse.ok) {
        throw new Error("Falha no upload da imagem de capa para o S3!");
      }

      // 3. Atualizar o estado e submeter
      // Boa prática: criar um novo objeto em vez de modificar a prop diretamente
      const updatedEmpresa = { ...empresa, urlCover: key };
      console.log("URL CAPA: ", key)
      
      handleSaveCover(updatedEmpresa)
      
      await onSubmit();

    } catch (error) {
      console.error(error);
      // Adicione um feedback de erro para o usuário aqui se desejar
    } finally {
      setLoading(false);
    }
  }

    const handleSaveCover = (newEmpresa) => {
      const service = new AuthService();
      const { id, urlCover } = newEmpresa;
      const json = { id, urlCover };
  
      service.put("/empresa/changeOnly", json).then((resp) => {
        const profile = JSON.parse(localStorage.getItem("_profile"));
        profile.empresa = resp;
        onUpdateCompany(resp);
        localStorage.setItem("_profile", JSON.stringify(profile));
        onUpdateCompany(resp);
      });
    };

  return (
    <CoverContainer
      sx={{
        backgroundImage: empresa.urlCover
          ? `url(${URL_IMAGEBOSS + empresa.urlCover})`
          : "none",
      }}
    >
      {loading && (
        <CoverLoading>
          <CircularProgress />
        </CoverLoading>
      )}

      {empresa.urlCover ? (
        <CoverLabel htmlFor="labelCover">
          <Box textAlign="center">
            <PublishIcon sx={{ fontSize: 80 }} />
            <Typography>Substituir capa</Typography>
          </Box>
        </CoverLabel>
      ) : (
        <CoverLabelEmpty htmlFor="labelCover">
          <Box textAlign="center">
            <PublishIcon sx={{ fontSize: 80 }} />
            <Typography>Adicionar capa</Typography>
          </Box>
        </CoverLabelEmpty>
      )}

      <input
        disabled={loading}
        type="file"
        id="labelCover"
        accept="image/*"
        style={{ display: "none" }}
        onChange={({ target }) => uploadFileServer(target.files[0])}
      />
    </CoverContainer>
  );
}

export default CoverInput;
